import { toast } from 'react-toastify';

export const showOverlaySubmitErrorToast = () => {
  toast.error('There was an error submitting your feedback. Please try again.');
};
